import React, { Component, useEffect} from 'react';
import GITHUB from '../image/github.png';
import '../css/styles.css';
import { Card, Button, CardTitle, CardText, CardImg, CardBody, CardFooter } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ME from '../image/a.jpeg';
import {PROJ} from '../res/proj';
import Menu from './menu';
import AOS from 'aos';
import 'aos/dist/aos.css'
class Project extends Component{
    
    constructor(props){
        super(props);
        this.state={
            proj:PROJ,
        }
    }
    
    renderProject(project){
        if(project!=null){
        const cmnts = this.state.proj.map(project => {
            
            if(project.pos==0){
                return(
                    <div data-AOS="fade-right" className="row mb-5" >
                        <div className="col-md">
                        <CardTitle><h3 align="left">{project.name}</h3></CardTitle>
                        <Card style={{backgroundColor:'#172a45'}} align="right">
                            <CardBody>
                                <p>
                                    {project.des}
                                </p>
                            </CardBody>
                            <CardFooter>
                            <p>View Source Code    <a href="github"><span><img class="icon" src={GITHUB}/></span></a></p>
                  
                            </CardFooter>
                         </Card>
                        </div>
                        <img src={project.img}  className="img-1 d-none d-sm-block" width="300" height="200" viewBox="0 0 400 400"  />
                       
                </div>
                )
            }
            else{
                return (
                <div data-AOS="fade-left" className="row mb-5" >
                   <img  src={project.img} className="img-1 d-none d-sm-block" width="300" height="200" viewBox="0 0 400 400"  />
                     <div className="col-md">
                     <CardTitle><h3 align="right">{project.name}</h3></CardTitle>
                        <Card style={{backgroundColor:'#172a45'}} align="right">
                            <CardBody>
                                <p>
                                    {project.des}
                                </p>
                            </CardBody>
                            <CardFooter>
                            <p>View Source Code    <a href="github"><span><img class="icon" src={GITHUB}/></span></a></p>
                  
                            </CardFooter>
                         </Card>
                    </div>
                </div>
            )}
        })
        return (
            <div className='col-12 '>
                {cmnts}

            </div>
        )
    }
}

    render(){
        
        const commentItem = this.renderProject(this.state.proj)
        return(
            <div className="">
                <h4 className="about ml-3">Project</h4><br/>
               {commentItem}
            </div>
        )
    }
    
}

export default Project;